import { api } from '@/lib/api-client.ts'
import {
  Issue,
  SingleIssueComment,
  SingleIssueEvent,
  StageLocations,
} from '@/routes/projectStages/issue/types/issue.ts'
import { IssueTypeT } from '@/components/common/menu/lib/types/navigationDataTypes.ts'
import { ProjectStagesUsersT } from '@/components/common/menu/lib/types/projectStagesUsers.ts'

export type PublicIssuePreviewResponse = {
  issue: Issue
  issueType: IssueTypeT | null
  comments: SingleIssueComment[]
  events: SingleIssueEvent[]
  stageLocations: StageLocations
  projectUsers: ProjectStagesUsersT
  stageLabel: string
}

export const getPublicIssuePreview = async (token: string): Promise<PublicIssuePreviewResponse> => {
  const response = await api.get(`/api/public/issues/${token}`)
  return response.data as PublicIssuePreviewResponse
}

export const publicIssueLoader = async ({
  params,
}: {
  params: Record<string, string | undefined>
}) => {
  const token = params.token
  if (!token) throw new Error('No token')

  return getPublicIssuePreview(token)
}
